import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useAccount, useProduct } from 'src/hooks'
import { PageSimpleFooter } from '../page-simple-footer'
import { hasWlpBranding } from 'src/utils/has-wlp-branding.util'
import { IAccount } from 'src/types'
import { FooterSkeleton } from './footer-skeleton'
import { BrandedFooter } from './branded-footer'

interface IProps {
  accountId?: string
  alwaysShowSimpleFooter?: boolean
}

export const PageFooter = ({ accountId, alwaysShowSimpleFooter }: IProps) => {
  const [, i18n] = useTranslation()
  const { productId, simpleProductId } = useParams()

  const productQueryEnabled = Boolean(productId || simpleProductId)

  const {
    data: product,
    isLoading: isProductLoading,
    isError: isProductError,
  } = useProduct(productId, i18n.language, simpleProductId)

  const accountIdFromProduct = (product as any)?.account_id as string | undefined
  const effectiveAccountId = accountId ?? accountIdFromProduct
  const accountQueryEnabled = Boolean(effectiveAccountId)
  const {
    data: account,
    isLoading: isAccountLoading,
    isError: isAccountError,
  } = useAccount(effectiveAccountId, i18n.language, accountQueryEnabled)

  if (alwaysShowSimpleFooter) {
    return <PageSimpleFooter showNavMenu />
  }

  const stillDerivingAccountId = productQueryEnabled && !effectiveAccountId && isProductLoading

  const cannotDecideWlpYet =
    accountQueryEnabled &&
    !hasWlpBranding(account as IAccount | null) &&
    (isAccountLoading || !account)

  if (stillDerivingAccountId || cannotDecideWlpYet) {
    return <FooterSkeleton />
  }

  if (hasWlpBranding(account as IAccount | null)) {
    return <BrandedFooter account={account} />
  }

  if (isProductError || isAccountError) {
    return <PageSimpleFooter showNavMenu />
  }

  return <PageSimpleFooter showNavMenu />
}
